export default __webpack_public_path__ + "static/media/truBeeRemovalDesktop.ce2d58be.jpg";